module.exports = __webpack_public_path__ + "img/time-start.d1b25995.svg";